module.exports = __webpack_public_path__ + "static/img/bg-es.3218c4df.png";